export default __webpack_public_path__ + "static/media/icons-integration-list.53c0e7b9.svg";